<mat-form-field appearance="outline" [hideRequiredMarker]="true"
  [formGroup]="group"
  [ngClass]="loading ? 'nsc-form-field-loading' : ''">
  <mat-label>{{placeholder}}</mat-label>
  <mat-select
    id="{{idx}}"
    formControlName="{{ controlName }}"
    autocomplete="off"
    (openedChange)="openedChange($event)"
    (selectionChange)="changeValue($event)" >
    @for (obj of selectObjects; track obj) {
      <mat-optgroup [label]="obj.label" id="{{idx}}_group">
        @for (obj2 of obj.options; track obj2; let i = $index) {
          <mat-option  id="{{idx}}_{{i}}" [value]="obj2.value">
            {{ obj2.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
  <mat-hint>{{ hint }} </mat-hint>
  @if (group.controls[controlName].invalid) {
    <mat-error>Error: {{ hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
  }
</mat-form-field>
